var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "30px",
    viewBox: "0 0 22 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FC179AF6-7270-4D81-B2F4-028198225E51") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3.0-Mojo-SignUp",
    transform: "translate(-1294.000000, -550.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-hover",
    transform: "translate(1200.000000, 526.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signUp-data-icon",
    transform: "translate(95.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 19.1995517,
    y1: 16.0057099,
    x2: 0.0000820237477,
    y2: 16.0004392,
    id: "Line-4",
    stroke: "#0964DE",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#45B209",
    strokeLinejoin: "round",
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9995517,
    y1: 22,
    x2: -2.99712693e-7,
    y2: 22,
    id: "Line-4",
    stroke: "#0964DE",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.1995517,
    y1: 28,
    x2: 0.0000813002866,
    y2: 28,
    id: "Line-4",
    stroke: "#0964DE",
    strokeLinecap: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon);
export default __webpack_public_path__ + "static/media/data-icon.65ffc6cd65e8a4b34999bd1eab865316.svg";
export { ForwardRef as ReactComponent };